export async function copyToClipboard(value: string) {
	try {
		return await navigator.clipboard.writeText(value);
	} catch (message) {
		console.error(message);
	}
}
